import { useState } from "react";
import {
  addDays,
  endOfMonth,
  endOfWeek,
  format,
  startOfMonth,
  startOfWeek,
} from "date-fns";
import { Link } from "react-router-dom";
import { useEvents, useUpcomingEvents } from "../lib/events";
import { SiteHeader } from "../components/platform/PlatformChrome";
import { Footer } from "../components/landing/Footer";
import { CalendarView } from "../components/calendar/CalendarView";
import { EventList } from "../components/calendar/EventList";

export default function PublicCalendar() {
  const [cursor, setCursor] = useState(() => new Date());

  // Range matches what MonthGrid actually displays (the surrounding weeks),
  // so events in the leading/trailing days outside the current month also
  // surface in the grid.
  const from = format(startOfWeek(startOfMonth(cursor), { weekStartsOn: 1 }), "yyyy-MM-dd");
  const to = format(addDays(endOfWeek(endOfMonth(cursor), { weekStartsOn: 1 }), 1), "yyyy-MM-dd");
  const monthQ = useEvents({ from, to, limit: 500 });
  const upcomingQ = useUpcomingEvents({ days: 60, limit: 12 });

  return (
    <>
      <SiteHeader />
      <main className="pt-24 md:pt-28 pb-24">
        <div className="container-edit max-w-[1100px]">
          <section className="mb-14">
            <CalendarView
              register="rich"
              cursor={cursor}
              onCursorChange={setCursor}
              events={monthQ.data?.events ?? []}
              basePath="/calendar"
            />
          </section>

          <section>
            <h2 className="font-display text-[clamp(1.5rem,3vw,2rem)] tracking-tight mb-7">Upcoming</h2>
            <EventList events={upcomingQ.data?.events ?? []} basePath="/calendar" />
          </section>

          <p className="sk-calendar-link">
            <Link to="/sankalpa">Compose a saṅkalpa for this day →</Link>
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
}
